module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "CommonDemoPage");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CommonDemoPage!./src/pages/Shop/Member/Personal/CommonDemoPage/index.js
// module id = 1919
// module chunks = 367